import * as React from 'react';

import { useClickTracker } from '@shared-ui/clickstream-analytics-context';

import { SearchCriteriaModel } from 'src/common/stores/models';

import { FilterModel, FilterOptionModel } from 'components/common/search-form/fields/filter-types';
import { SortAndFilterModel } from './filter-types';

import { UitkExpandoList, UitkExpandoListItem } from 'uitk-react-expando';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { Checkboxes } from './checkbox-group';

export const CheckboxGroupExpandoList = ({
  getFilterType,
  isChecked,
  model,
  modelKey,
  sortAndFilterOptions,
  handleChange,
  checkbox,
  getFirstAndLastIndices,
  isVisible,
}: {
  getFilterType: (option: FilterOptionModel) => string;
  isChecked: (option: FilterOptionModel) => boolean;
  model: SearchCriteriaModel;
  modelKey: string;
  sortAndFilterOptions: SortAndFilterModel;
  handleChange: (evt) => void;
  checkbox: FilterModel;
  getFirstAndLastIndices: (
    checkboxOptions: FilterOptionModel[],
    modelValues: string[]
  ) => {
    firstIndex: number;
    lastIndex: number;
  };
  isVisible: boolean;
}) => {
  const track = useClickTracker();

  return (
    <div data-stid={isVisible ? 'checkbox-group-expando-list-visible' : 'checkbox-group-expando-list'}>
      <UitkSpacing margin={{ blockstart: 'two' }}>
        <UitkExpandoList>
          <div className="tnl-collapsing-filter-expando-list">
            <UitkExpandoListItem
              isVisible={isVisible}
              analytics={{
                id: checkbox.title,
                callback: id => {
                  const idArr = id.split('.');
                  track(`${idArr[0]}.ViewAllFilters.${idArr[1]}`, `${checkbox.title}.ViewAllFilters`);
                },
              }}
              expandoTitle={
                <UitkHeading size={7} tag="h4">
                  {checkbox.label}
                </UitkHeading>
              }
              expandoDescription={
                <div className="tnl-collapsing-filter-expando-checkbox">
                  <Checkboxes
                    getFilterType={getFilterType}
                    getFirstAndLastIndices={getFirstAndLastIndices}
                    handleChange={handleChange}
                    isChecked={isChecked}
                    model={model}
                    modelKey={modelKey}
                    sortAndFilterOptions={sortAndFilterOptions}
                  />
                </div>
              }
            />
          </div>
        </UitkExpandoList>
      </UitkSpacing>
    </div>
  );
};
